/*
 * Copyright (c) Schrocken Inc.
 * Author: Nitin
 * File Description: Reducer file for ecosystem creation
 */

import {
  GET_MOSYMPHONY_SETTINGS,
  UPDATE_MOSYMPHONY_SETTINGS,
  RESET_MOSYMPHONY_SETTINGS,
  ADD_ORGANIZATION,
  GET_ORGANIZATION,
  COLLABORATOR_TYPE,
  COLLABORATOR_ROLE,
  ECOSYSTEM_TYPE,
  GET_ECOSYSTEMS,
  SEND_BRAND_OWNER_INVITATION,
} from '../actions/types';

const initialState = {
  addOrg: {},
  Organization: [],
  collaboratorType: [],
  collaboratorRole: [],
  ecosystemType: [],
  brandOwnerInfo: [],
  ecosystems: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_MOSYMPHONY_SETTINGS:
      return {
        ...state,
        mosymphonySettings: action.payload,
      };
    case UPDATE_MOSYMPHONY_SETTINGS:
      return {
        ...state,
        settingsUpdate: action.payload,
      };
    case RESET_MOSYMPHONY_SETTINGS:
      return {
        ...state,
        settingsReset: action.payload,
      };
    case ADD_ORGANIZATION:
      return {
        ...state,
        addOrg: action.payload,
      }; 
    case GET_ORGANIZATION:
      return {
        ...state,
        Organization: action.payload,
      };
    case COLLABORATOR_TYPE:
      return {
        ...state,
        collaboratorType: action.payload,
      };
    case COLLABORATOR_ROLE:
      return {
        ...state,
        collaboratorRole: action.payload,
      };
    case ECOSYSTEM_TYPE:
      return {
        ...state,
        ecosystemType: action.payload,
      };
    case GET_ECOSYSTEMS:
      return {
        ...state,
        ecosystems: action.payload,
      };
    case SEND_BRAND_OWNER_INVITATION:
      return {
        ...state,
        brandOwnerInfo: action.payload,
      };
    default:
      return state;
  }
}
